import React from 'react'
import SlideImage from '../Components/SlideImage'

const Contact = () => {
  return (
    <div>
      <SlideImage/>
      <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.2602486751166!2d77.143098!3d28.471708099999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1f0018d1e1b1%3A0x61b748b34e1f0616!2sAkoi%20Foundation!5e0!3m2!1sen!2sin!4v1736274063292!5m2!1sen!2sin" 
          width="300" 
          height="300" 
          className='mx-auto my-4 border border-black rounded-md md:w-96'
          loading="lazy" 
          referrerpolicy="no-referrer-when-downgrade">
          </iframe>

          <div className='flex flex-wrap mx-8 my-8 md:mx-60'>
            <div className='border p-8  bg-gray-200 md:w-96 '>
              <h1 className='font-semibold text-2xl my-3'>AKOI FOUNDATION</h1>
              <p className='text-xl my-4'>14/19, Aya Nagar Jonapur Link Rd, New Delhi, Delhi 110047</p>
              <p className='text-xl my-4'>Near Sati Mata Mandir</p>
              <p className='text-xl my-4 font-semibold'>Mob : <a href="tel:9354623839">+91-9354623839</a> , <a href="tel:9354615602">+91-9354615602 </a></p>
              <p className='text-xl my-4 font-semibold'>EMAIL: <a href='mailto:akoifoundation002@gmail.com' className='text-blue-400 underline'>akoifoundation@gmail.com</a></p> 
              <p className='text-lg my-4'>Timings <span className='font-semibold'>: <span>Mon-Sat :</span> 9AM - 5PM</span></p>
            </div>
            <div className='border p-8 my-8 bg-gray-200 md:mx-10'>
              <h1 className='font-bold text-gray-600 text-2xl my-3'>HAVE QUESTION?</h1>
              <img src="/assets/QuestionMark.jpg" alt="question"
                className='rounded-full w-40 h-40 mx-8'
                />
              <p className='text-xl my-4 font-semibold'>Mob: <a href="tel:9354623839">+91-9354623839</a> , <a href="tel:9354615602">+91-9354615602 </a></p>
              <p className='text-xl my-4 font-semibold'>EMAIL: <a href='mailto:akoifoundation002@gmail.com' className='text-blue-400 underline'>akoifoundation@gmail.com</a></p> 
            </div>
          </div>
    </div>
  )
}

export default Contact